import React from "react";
import {documentReady} from "../../utils/global-functions";
import {graphql, Link, useStaticQuery} from "gatsby"
import scrollTo from "gatsby-plugin-smoothscroll";

const IdentityNav = ({pageContext}) => {
    const currentHref = typeof window !== 'undefined' && window.document ? window?.location.href : '';
    const query = useStaticQuery(graphql`
    query {
        menu: markdownRemark (
            frontmatter: {
                name: { eq: "menu-identity" }
            }
        ) {
            frontmatter {
                en {
                    home {
                        url
                        name
                    }
                    functionalities {
                        url
                        name
                    }
                    useCases {
                        url
                        name
                    }
                    legality {
                        url
                        name
                    }
                    faq {
                        url
                        name
                    }
                    contact {
                        url
                        name
                    }
                    demo {
                        url
                        name
                    }
                }
                es{
                    home {
                        url
                        name
                    }
                    functionalities {
                        url
                        name
                    }
                    useCases {
                        url
                        name
                    }
                    legality {
                        url
                        name
                    }
                    faq {
                        url
                        name
                    }
                    contact {
                        url
                        name
                    }
                    demo {
                        url
                        name
                    }
                }
            }
        }
    }
    `);
    const menu = query.menu.frontmatter[pageContext.locale.path.default];
    const index = menu.home.url;
    const functionalities = menu.functionalities.url;
    const useCase = menu.useCases.url;
    const legality = menu.legality.url;
    const faq = menu.faq.url;
    let navbar;
    let sticky;

    documentReady(() => {
        navbar = document.getElementById("navbar");
        sticky = navbar.offsetTop > 83 ? navbar.offsetTop : 83;

        window.onscroll = function () {
            onScroll()
        };

        document.querySelectorAll('.brand-link').forEach(element => {
            element.addEventListener('click', e => {
                if (element.getAttribute('href') === window.location.pathname) {
                    e.preventDefault();
                    scrollTo('#product-top');
                }
            });
        });
    })

    function onScroll() {
        if (window.pageYOffset >= sticky) {
            navbar.classList.add("sticky")
        } else {
            navbar.classList.remove("sticky");
        }
    }

    function openNav() {
        document.getElementById("myNav").style.width = "100%";
    }

    function closeNav() {
        document.getElementById("myNav").style.width = "0%";
    }

    return (
        <>
            <div id="myNav" className="overlay-side">
                <span className="closebtn" onClick={closeNav}>&times;</span>
                <div className="overlay-side-content">
                    <Link to={index}>
                        <span className={currentHref.includes(index) ? 'page-active' : ''}>{menu.home.name}</span>
                    </Link>
                    <Link to={functionalities}>
                        <span className={currentHref.includes(functionalities) ? 'page-active' : ''}>{menu.functionalities.name}</span>
                    </Link>
                    <Link to={useCase}>
                        <span className={currentHref.includes(useCase) ? 'page-active' : ''}>{menu.useCases.name}</span>
                    </Link>
                    <Link to={legality}>
                        <span className={currentHref.includes(legality) ? 'page-active' : ''}>{menu.legality.name}</span>
                    </Link>
                    <a href="#" data-toggle="modal" data-target="#modal-contact-sales">
                        <span className="text-tecalis spacing" style={{fontWeight: '400'}}>{menu.contact.name}</span>
                    </a>
                    <Link to={faq}>
                        <span className={currentHref.includes(faq) ? 'page-active' : ''}>{menu.faq.name}</span>
                    </Link>
                    <a href="#" data-toggle="modal" data-target="#modal-contact-sales" className="text-primary mt-5"><b>{menu.demo.name}</b></a>
                </div>
            </div>

            <div id="navbar">
                <nav className="navbar navbar-expand-lg navbar-light navbar-togglable bg-grey border-bottom">
                    <div className="container-fluid">
                        <div className="container">
                            <Link to={index} className="navbar-brand brand-link">
                                <img src={require("../../img/logo-identity-portal.png").default} className="navbar-brand-img" alt="Tecalis"/>
                            </Link>

                            <ul className="navbar-nav mr-auto ml-10 menu nav-desktop">
                                <li className="nav-item">
                                    <Link className="nav-link text-black brand-link" to={functionalities}>
                                        <span className={currentHref.includes(functionalities) ? 'page-active' : ''}>{menu.functionalities.name}</span>
                                    </Link>
                                </li>

                                <li className="nav-item">
                                    <Link className="nav-link text-black brand-link" to={useCase}>
                                        <span className={currentHref.includes(useCase) ? 'page-active' : ''}>{menu.useCases.name}</span>
                                    </Link>
                                </li>

                                <li className="nav-item">
                                    <Link className="nav-link text-black brand-link" to={legality}>
                                        <span className={currentHref.includes(legality) ? 'page-active' : ''}>{menu.legality.name}</span>
                                    </Link>
                                </li>

                                <li className="nav-item">
                                    <Link className="nav-link text-black brand-link" to={faq}>
                                        <span className={currentHref.includes(faq) ? 'page-active' : 'opacity-menu'}>{menu.faq.name}</span>
                                    </Link>
                                </li>
                            </ul>

                            <ul className="navbar-nav ml-auto ml-10 nav-desktop">
                                <a href="#" className="btn-primary-outline mr-2" data-toggle="modal" data-target="#modal-contact-sales">{menu.contact.name}</a>

                                <a href="#" data-toggle="modal" data-target="#modal-contact-sales" className="btn btn-primary spacing btn-sm1">{menu.demo.name}</a>
                            </ul>

                            <span className="ml-auto nav-mobile" onClick={openNav} style={{cursor: 'pointer'}}> &#9776; Menú</span>
                        </div>
                    </div>
                </nav>
            </div>
        </>
    )
}

export default IdentityNav
